// assets
import { IconCreditCard } from "@tabler/icons";

// constant
const icons = {
  IconCreditCard,
};

// ==============================|| LIQUIDACIONES MENU ITEMS ||============================== //

const liquidaciones = {
  id: "Liquidaciones",
  title: "",
  type: "group",
  children: [
    {
      id: "Liquidaciones",
      title: "Liquidaciones",
      type: "item",
      url: "/liquidaciones/liquidaciones-list",
      icon: icons.IconCreditCard,
      breadcrumbs: false,
    },
  ],
};

export default liquidaciones;
